// i18n area 'tasks' (task #127): sections macrotasks, tasks.
// Split out of the old monolithic dictionaries.ts by scripts/split-dictionaries.mjs;
// since the split, these files are the SOURCE — add and edit keys here. The script
// only re-runs to re-split a merged monolithic dictionaries.ts (see its header).

export const enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Composed operations — resumable from the failed step, or abortable',
    colType: 'Type',
    colTarget: 'Target',
    colPhase: 'Phase',
    colSteps: 'Steps',
    empty: 'No macrotasks',
    detail: 'Details',
    failedAt: 'failed at',
    resume: 'Retry from the failed step',
    abort: 'Abort',
    cancel: 'Cancel',
    actionError: 'The action was refused'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Search by type or target',
    type: 'Type',
    target: 'Target',
    phaseLabel: 'Phase',
    progress: 'Progress',
    started: 'Started',
    finished: 'Finished',
    node: 'Node',
    empty: 'No tasks',
    loadError: 'Could not load the tasks — is the TVirt backend reachable?',
    limboHint: "Node '{node}' unreachable since {time} — the task holds its target's write lease until the node returns or is attested down",
    nodeAttested: 'Node attested down',
    phase: {
      queued: 'Queued',
      running: 'Running',
      succeeded: 'Succeeded',
      failed: 'Failed',
      cancelled: 'Canceled',
      'failed-at-step': 'Failed at step',
      aborted: 'Aborted'
    },
    dropdown: {
      tooltip: 'Running tasks',
      title: 'Running tasks',
      empty: 'No tasks in progress',
      viewAll: 'View all tasks'
    },
    detail: {
      open: 'Details',
      scope: 'Scope',
      message: 'Message',
      params: 'Parameters',
      result: 'Result',
      errorTitle: 'Error',
      steps: 'Steps',
      failedAt: 'failed at',
      superseded: 'superseded',

      // Dialog standard (round #156): the child's place in the parent's plan,
      // the parent itself (openable in place) and the culprit step.
      step: 'Step',
      parent: 'Parent task',
      failedStep: 'Failed step',
      log: 'Log',
      logEmpty: 'No log entries yet',
      close: 'Close'
    },
    actions: {
      cancel: 'Cancel',
      resume: 'Retry from the failed step',
      abort: 'Abort (undo completed steps)',
      refused: 'The action was refused'
    }
  },
  events: {
    loadError: 'Could not load the journal — is the TVirt backend reachable?',
    title: 'Events',
    subtitle: "The cluster's historical memory: accomplished facts, newest first",
    filterSeverity: 'Severity',
    filterCategory: 'Category',
    filterAll: 'All',
    searchLabel: 'Search',
    searchPlaceholder: 'Search the whole journal',
    subjectFilter: 'Events of {subject} — show all',
    colAt: 'When',
    colSeverity: 'Severity',
    colType: 'Type',
    colSubject: 'Subject',
    colActor: 'Who',
    colNode: 'Node',
    colMessage: 'Message',
    empty: 'No events',
    loadMore: 'Load more',
    actorSystem: 'system',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Event ID',
    taskCollectedHint: 'The task has a shorter retention: once collected the link no longer resolves',
    severity: {
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
      critical: 'Critical'
    },
    category: {
      lifecycle: 'Lifecycle',
      config: 'Configuration',
      availability: 'Availability',
      security: 'Security'
    },

    // Round L (L5): il testo umano dei tre fatti ha.netsvc* (PROPOSAL 11) —
    // la pagina Eventi è la superficie per-servizio (deep-link, #246); gli
    // altri type restano grezzi per scelta ratificata.
    type: {
      haNetsvcFailedOver: 'Network service failed over',
      haNetsvcNoCandidate: 'Network service without a candidate node',
      haNetsvcReaped: 'Local instance reaped on rejoin',
      netsvcFloatipMoved: 'Floating IP moved to another holder',
      netsvcFloatipNoHolder: 'Floating IP without a healthy target',
      haAppFailedOver: 'App instance failed over',
      haAppNoCandidate: 'App instance without a candidate node',
      haAppStorageLocalSkip: 'App instance not failed over: persistent data local to the dead node',
      haAppReaped: 'Local pod of the App instance reaped on rejoin'
    }
  },

  // Sistema > Audit (#113): il REGISTRO degli atti, fratello del giornale e non
  // la sua vista — un evento racconta un fatto del sistema, un record d'audit
  // dice CHI l'ha chiesto e sopravvive a una ritenzione pensata per altro.
  audit: {
    loadError: 'Could not load the audit register — is the TVirt backend reachable?',
    title: 'Audit',
    subtitle: 'Who did what, when, on which object — attempted acts, refusals included',
    filterOutcome: 'Outcome',
    filterAll: 'All',
    filterSudo: 'Elevated acts only',
    colAt: 'When',
    colActor: 'Who',
    colAction: 'Action',
    colTarget: 'Object',
    colOutcome: 'Outcome',
    colNode: 'Node',
    empty: 'No acts recorded',
    loadMore: 'Load more',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Route',
    detailProblem: 'Reason',
    detailTask: 'Task',
    detailClientIp: 'From',
    detailId: 'Record ID',
    detailSession: 'Session',
    taskHint: 'The outcome of an accepted act lives in the event journal, under this same task id',
    outcome: {
      succeeded: 'Done',
      accepted: 'Accepted',
      denied: 'Refused',
      rejected: 'Rejected',
      failed: 'Failed'
    }
  },
  notifications: {
    loadError: 'Could not load the notifications — is the TVirt backend reachable?',
    actionError: 'The action was refused',
    title: 'Notifications',
    subtitle: 'The destinations the journal\'s facts leave the cluster for',
    rulesTitle: 'Rules',
    rulesSubtitle: 'Which facts leave, and for where',
    deliveriesTitle: 'Deliveries',
    deliveriesSubtitle: 'The outcome of every notification, with the reason when it fails',
    colName: 'Name',
    colKind: 'Type',
    colWhere: 'Where',
    colScope: 'Scope',
    colSeverity: 'Severity',
    colMatch: 'Filter',
    colTargets: 'Destination',
    colAt: 'When',
    colState: 'State',
    colEvent: 'Event',
    colAttempts: 'Attempts',
    colOutcome: 'Outcome',
    empty: 'Nothing here',
    matchAll: 'every fact',
    test: 'Test',
    testOk: 'Test notification delivered to {target}',
    testFailed: 'Test to {target} failed: {reason}',
    retry: 'Requeue',
    retried: 'Delivery requeued',
    grouped: 'and {count} more repetitions',
    state: {
      failed: 'Failed',
      pending: 'Queued',
      sending: 'Sending',
      sent: 'Sent'
    },
    tabTargets: 'Destinations',
    tabRules: 'Rules',
    tabDeliveries: 'Deliveries',
    targetCreateTitle: 'New destination',
    ruleCreateTitle: 'New rule',
    nameHint: 'Lowercase, digits and dashes; unique per scope',
    kindImmutableHint: 'Immutable: changing the type means creating another destination',
    kindSmtp: 'Mail (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'State',
    enabledOn: 'Active',
    enabledOff: 'Suspended',
    smtpHost: 'SMTP server',
    smtpPort: 'Port',
    smtpPortHint: 'Usual: 25 without TLS, 587 with starttls, 465 with tls',
    smtpSecurity: 'Security',
    smtpFrom: 'Sender',
    smtpTo: 'Recipients',
    smtpToHint: 'One or more comma-separated addresses',
    webhookUrl: 'URL',
    payload: 'Payload',
    payloadHint: 'With minimal the event message and data never leave the cluster',
    credential: 'Credential',
    credentialNone: 'None',
    credentialHintSmtp: 'The relay account from the keystore; none means anonymous SMTP',
    credentialHintWebhook: 'The signing secret from the keystore; unsigned, anyone who knows the URL can pose as the cluster',
    minSeverityHint: 'A threshold, not a set: this severity and above',
    categories: 'Categories',
    categoriesHint: 'Empty = all',
    types: 'Event types',
    typesHint: 'Comma-separated; empty = all. An unknown type is refused',
    targetsHint: "At least one; they must live in the rule's scope or an ancestor of it",
    recursiveOn: 'Child scopes too',
    recursiveOff: 'This scope only',
    recursiveHint: 'Resources live in the leaves: without children a rule on the root notifies almost nothing',
    repeatWindow: 'Grouping window (s)',
    repeatWindowHint: 'Within the window repeats send no mail: they are counted on the first one. 0 disables',
    targetInUseError: 'Destination {name} is still used by a rule'
  }
}

export const itIT: typeof enUS = {
  macrotasks: {
    title: 'Macrotask',
    subtitle: 'Operazioni composte — riprendibili dal passo fallito, o annullabili',
    colType: 'Tipo',
    colTarget: 'Oggetto',
    colPhase: 'Fase',
    colSteps: 'Passi',
    empty: 'Nessun macrotask',
    detail: 'Dettagli',
    failedAt: 'fallito a',
    resume: 'Riprova dal passo fallito',
    abort: 'Annulla tutto',
    cancel: 'Cancella',
    actionError: "L'azione è stata rifiutata"
  },
  tasks: {
    title: 'Task',
    searchPlaceholder: 'Cerca per tipo o target',
    type: 'Tipo',
    target: 'Target',
    phaseLabel: 'Fase',
    progress: 'Avanzamento',
    started: 'Iniziato',
    finished: 'Terminato',
    node: 'Nodo',
    empty: 'Nessun task',
    loadError: 'Impossibile caricare i task — il backend TVirt è raggiungibile?',
    limboHint: "Nodo '{node}' irraggiungibile dalle {time} — il task trattiene il write lease sul suo target finché il nodo non torna o non viene attestato spento",
    nodeAttested: 'Nodo attestato spento',
    phase: {
      queued: 'In coda',
      running: 'In esecuzione',
      succeeded: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato',
      'failed-at-step': 'Fallito a un passo',
      aborted: 'Interrotto'
    },
    dropdown: {
      tooltip: 'Task in corso',
      title: 'Task in corso',
      empty: 'Nessun task in corso',
      viewAll: 'Vedi tutti i task'
    },
    detail: {
      open: 'Dettagli',
      scope: 'Ambito',
      message: 'Messaggio',
      params: 'Parametri',
      result: 'Risultato',
      errorTitle: 'Errore',
      steps: 'Passi',
      failedAt: 'fallito a',
      superseded: 'superato',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Passo',
      parent: 'Task padre',
      failedStep: 'Passo fallito',
      log: 'Log',
      logEmpty: 'Ancora nessuna riga di log',
      close: 'Chiudi'
    },
    actions: {
      cancel: 'Cancella',
      resume: 'Riprova dal passo fallito',
      abort: 'Annulla tutto (undo dei passi completati)',
      refused: "L'azione è stata rifiutata"
    }
  },
  events: {
    loadError: 'Impossibile caricare il giornale — il backend TVirt è raggiungibile?',
    title: 'Eventi',
    subtitle: 'La memoria storica del cluster: fatti compiuti, dal più recente',
    filterSeverity: 'Gravità',
    filterCategory: 'Categoria',
    filterAll: 'Tutte',
    searchLabel: 'Cerca',
    searchPlaceholder: 'Cerca in tutto il giornale',
    subjectFilter: 'Eventi di {subject} — mostra tutti',
    colAt: 'Quando',
    colSeverity: 'Gravità',
    colType: 'Tipo',
    colSubject: 'Soggetto',
    colActor: 'Chi',
    colNode: 'Nodo',
    colMessage: 'Messaggio',
    empty: 'Nessun evento',
    loadMore: 'Carica altri',
    actorSystem: 'sistema',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID evento',
    taskCollectedHint: 'Il task ha una ritenzione più corta: se è già stato collezionato il collegamento non risponde',
    severity: {
      info: 'Informazione',
      warning: 'Avviso',
      error: 'Errore',
      critical: 'Critico'
    },
    category: {
      lifecycle: 'Ciclo di vita',
      config: 'Configurazione',
      availability: 'Disponibilità',
      security: 'Sicurezza'
    },

    // Round L (L5): il testo umano dei tre fatti ha.netsvc* (PROPOSAL 11) —
    // la pagina Eventi è la superficie per-servizio (deep-link, #246); gli
    // altri type restano grezzi per scelta ratificata.
    type: {
      haNetsvcFailedOver: 'Failover del servizio di rete',
      haNetsvcNoCandidate: 'Servizio di rete senza nodo candidato',
      haNetsvcReaped: 'Istanza locale mietuta al rientro',
      netsvcFloatipMoved: 'IP flottante spostato su un altro detentore',
      netsvcFloatipNoHolder: 'IP flottante senza un bersaglio sano',
      haAppFailedOver: "Failover dell'istanza App",
      haAppNoCandidate: 'Istanza App senza nodo candidato',
      haAppStorageLocalSkip: 'Istanza App non spostata: dati persistenti locali al nodo morto',
      haAppReaped: "Pod locale dell'istanza App mietuto al rientro"
    }
  },
  audit: {
    loadError: "Impossibile caricare il registro d'audit — il backend TVirt è raggiungibile?",
    title: 'Audit',
    subtitle: 'Chi ha fatto cosa, quando, su quale oggetto — atti tentati, rifiuti compresi',
    filterOutcome: 'Esito',
    filterAll: 'Tutti',
    filterSudo: 'Solo atti elevati',
    colAt: 'Quando',
    colActor: 'Chi',
    colAction: 'Azione',
    colTarget: 'Oggetto',
    colOutcome: 'Esito',
    colNode: 'Nodo',
    empty: 'Nessun atto registrato',
    loadMore: 'Carica altri',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rotta',
    detailProblem: 'Motivo',
    detailTask: 'Task',
    detailClientIp: 'Da',
    detailId: 'ID record',
    detailSession: 'Sessione',
    taskHint: "L'esito di un atto accettato vive nel giornale eventi, sotto questo stesso id di task",
    outcome: {
      succeeded: 'Riuscito',
      accepted: 'Accettato',
      denied: 'Rifiutato',
      rejected: 'Respinto',
      failed: 'Fallito'
    }
  },
  notifications: {
    loadError: 'Impossibile caricare le notifiche — il backend TVirt è raggiungibile?',
    actionError: "L'azione è stata rifiutata",
    title: 'Notifiche',
    subtitle: 'Le destinazioni verso cui i fatti del giornale escono dal cluster',
    rulesTitle: 'Regole',
    rulesSubtitle: 'Quali fatti escono, e verso dove',
    deliveriesTitle: 'Consegne',
    deliveriesSubtitle: 'L\'esito di ogni notifica, con il perché quando fallisce',
    colName: 'Nome',
    colKind: 'Tipo',
    colWhere: 'Dove',
    colScope: 'Scope',
    colSeverity: 'Gravità',
    colMatch: 'Filtro',
    colTargets: 'Destinazione',
    colAt: 'Quando',
    colState: 'Stato',
    colEvent: 'Evento',
    colAttempts: 'Tentativi',
    colOutcome: 'Esito',
    empty: 'Nessuna riga',
    matchAll: 'tutti i fatti',
    test: 'Prova',
    testOk: 'Notifica di prova consegnata a {target}',
    testFailed: 'Prova verso {target} fallita: {reason}',
    retry: 'Rimetti in coda',
    retried: 'Consegna rimessa in coda',
    grouped: 'e altre {count} ripetizioni',
    state: {
      failed: 'Fallita',
      pending: 'In coda',
      sending: 'In invio',
      sent: 'Inviata'
    },
    tabTargets: 'Destinazioni',
    tabRules: 'Regole',
    tabDeliveries: 'Consegne',
    targetCreateTitle: 'Nuova destinazione',
    ruleCreateTitle: 'Nuova regola',
    nameHint: 'Minuscole, cifre e trattini; unico per scope',
    kindImmutableHint: "Immutabile: cambiare tipo vuol dire creare un'altra destinazione",
    kindSmtp: 'Posta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stato',
    enabledOn: 'Attiva',
    enabledOff: 'Sospesa',
    smtpHost: 'Server SMTP',
    smtpPort: 'Porta',
    smtpPortHint: 'Abituale: 25 senza TLS, 587 con starttls, 465 con tls',
    smtpSecurity: 'Sicurezza',
    smtpFrom: 'Mittente',
    smtpTo: 'Destinatari',
    smtpToHint: "Uno o piu' indirizzi separati da virgola",
    webhookUrl: 'URL',
    payload: 'Contenuto',
    payloadHint: "Con minimal messaggio e dati dell'evento non escono dal cluster",
    credential: 'Credenziale',
    credentialNone: 'Nessuna',
    credentialHintSmtp: 'Utenza del relay dal keystore; nessuna significa SMTP anonimo',
    credentialHintWebhook: "Segreto di firma dal keystore; senza firma chiunque conosca l'URL puo' fingersi il cluster",
    minSeverityHint: "Soglia, non insieme: da questa gravita' in su",
    categories: 'Categorie',
    categoriesHint: 'Vuoto = tutte',
    types: 'Tipi di evento',
    typesHint: 'Separati da virgola; vuoto = tutti. Un tipo sconosciuto viene rifiutato',
    targetsHint: 'Almeno una; devono stare nello scope della regola o in un suo antenato',
    recursiveOn: 'Anche gli scope figli',
    recursiveOff: 'Solo questo scope',
    recursiveHint: 'Le risorse vivono nelle foglie: senza i figli una regola sulla radice notifica quasi nulla',
    repeatWindow: 'Finestra di raggruppamento (s)',
    repeatWindowHint: 'Entro la finestra le ripetizioni non generano posta: si contano sulla prima. 0 disattiva',
    targetInUseError: "La destinazione {name} e' ancora usata da una regola"
  }
}
